export default {
  getDump(state) {
    return state.dump
  }
}
